var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.parentClass},_vm._l((_vm.brands),function(brand,index){return _c('div',{key:index,class:_vm.brandClass},[_c('img',{staticClass:"img-fluid",attrs:{"src":brand.image,"alt":brand.name,"loading":"lazy"}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }